import { render, staticRenderFns } from "./wysiwyg-editor.vue?vue&type=template&id=0a6154f0&scoped=true&"
import script from "./wysiwyg-editor.vue?vue&type=script&lang=js&"
export * from "./wysiwyg-editor.vue?vue&type=script&lang=js&"
import style0 from "./wysiwyg-editor.vue?vue&type=style&index=0&id=0a6154f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6154f0",
  null
  
)

export default component.exports